function getDirection(delta) {
  if (delta > 0) {
    return 'up'
  } else if (delta < 0) {
    return 'down'
  }

  return null
}

const Diff = ({ value }) => {
  const direction = getDirection(value)

  return (
    <div
      style={{
        height: 22,
        width: 54,
        borderRadius: 3,
        backgroundColor: direction === 'down' ? '#FC6768' : '#69B46C',
        display: 'flex',
        color: 'white',
        fontWeight: 500,
        alignItems: 'center',
        userSelect: 'none',
        paddingLeft: 7,
        paddingRight: 7,
        fontSize: 14,
        boxSizing: 'border-box'
      }}
    >
      <svg width={18} height={9} fill="none" xmlns="http://www.w3.org/2000/svg">
        {direction === 'up' && <path d="M6.938 0l6 9h-12l6-9z" fill="#fff" />}
        {direction === 'down' && <path d="M6 9L0 0h12L6 9z" fill="#fff" />}
        {!direction && <circle cx="6" cy="5" r="4" fill="white" />}
      </svg>
      <div
        style={{
          display: 'flex',
          flex: 1,
          textAlign: 'center',
          justifyContent: 'center'
        }}
      >
        {value}
      </div>
    </div>
  )
}

export default Diff
